(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coverflow-3d-slider"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.myCollectionSwiper', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 30,
    speed: 900,
    coverflowEffect: {
      rotate: 15, // smaller angle for subtle 3D
      stretch: 0,
      depth: 200,
      modifier: 1,
      slideShadows: false,
    },
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 4 },
      1400: { slidesPerView: 4 },
    },
  });

  

  } catch(e) { console.error(e); }
})();
})();
